<template>
  <div class="invitation-preview">
    <div class="invitation-preview__avatar">
      <router-link
        :to="{
          name: 'TeamPage',
          params: { link: invitationData.team.link },
        }"
      >
        <el-avatar class="event-table__avatar" :size="50">
          <activity-image :activity="invitationData.team.activityId" :alt="invitationData.team.name" />
        </el-avatar>
      </router-link>
    </div>

    <div class="invitation-preview__content">
      <div class="invitation-preview__heading">
        <span class="invitation-preview__title">
          {{ invitationData.team.name }}
        </span>

        <span class="invitation-preview__date" v-if="invitationData.createdOn">
          {{ formatDate(invitationData.createdOn, SHORT_DATE_FORMAT) }}
        </span>
      </div>

      <div class="invitation-preview__comments" v-if="invitationData.comments">
        Organizer: {{ invitationData.comments }}
      </div>
    </div>

    <div class="invitation-preview__actions">
      <el-button
        @click="requestAcceptUserInvitation"
        type="primary"
        :disabled="isButtonDisabled('change-invitation-status')"
      >
        Accept
      </el-button>
      <el-button
        @click="requestRevokeUserInvitation"
        :disabled="isButtonDisabled('change-invitation-status')"
      >
        Decline
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  acceptTeamInvitation,
  rejectedTeamInvitation,
} from '@/api/team.js';
import {
  SHORT_DATETIME_FORMAT,
  SHORT_DATE_FORMAT,
  formatDate,
} from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

import ActivityImage from '@/components/common/ActivityImage.vue';

export default {
  components: { ActivityImage },
  name: 'TeamInvitationPreview',
  props: {
    invitationData: {
      type: Object,
      required: true,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      SHORT_DATETIME_FORMAT,
      SHORT_DATE_FORMAT,
    };
  },
  methods: {
    formatDate,
    showMessage,
    async requestAcceptUserInvitation() {
      this.disableButton('change-invitation-status');
      const { teammateId } = this.invitationData;
      const { success } = await acceptTeamInvitation({ teammateId });
      this.enableButton('change-invitation-status');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Invitation has been accepted',
        });
        this.$emit('update-data');
      }
    },
    async requestRevokeUserInvitation() {
      this.disableButton('change-invitation-status');
      const { teammateId } = this.invitationData;
      const { success } = await rejectedTeamInvitation({ teammateId });
      this.enableButton('change-invitation-status');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Invitation has been declined',
        });
        this.$emit('update-data');
      }
    },
  },
};
</script>

<style lang="scss">
.invitation-preview {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }
  &__content {
    flex-grow: 1;
    margin-right: var(--global-dimension-size-250);
  }
  &__heading {
  }
  &__title {
    font-weight: 500;
  }
  &__date {
    margin-left: var(--global-dimension-size-200);
    font-size: var(--font-size-200);
  }
  &__expiration-date {
    margin-top: var(--global-dimension-size-65);
    font-size: var(--font-size-200);
  }
  &__comments {
    margin-top: var(--global-dimension-size-125);
    padding: var(--global-dimension-size-125);
    background-color: var(--color-primary-200);
    font-size: var(--font-size-200);
  }
  &__actions {
  }
}
</style>
